import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import {
	fetchQuizProjects,
	fetchQuizzesByInputSearch
} from "actions/quiz.actions"
import eventUnitsStyle from '../../shared/assets/jss/material-dashboard-pro-react/views/eventUnitsStyle'
import { withStyles } from '@material-ui/core/styles'
import { withIntl } from "@hlcr/ui/Intl"
import { PaginatedDataModel } from "shared/models/paginatedData.model"
import List from './List'

class QuizSearchList extends React.Component {
	pathSegment = 'quizzes'
	languageKey = 'quiz'

	constructor(props) {
		super(props)
		this.state = {
			search: ''
		}
	}

	componentDidMount() {
		const { searchQuery } = this.props
		if (searchQuery) {
			this.setState({ search: searchQuery })
			this.props.fetchQuizzesByInputSearch(searchQuery)
		} else {
			this.fetchPage(1)
		}
	}

	componentWillUnmount() {
		clearTimeout(this.timer)
	}

	fetchPage = page => {
		this.props.history.push(`/${this.pathSegment}/page/${page}`)
		this.props.fetchQuizProjects(page)
	}

	triggerChange = (search, WAIT_INTERVAL) => {
		if (search && search.length > 0) {
			clearTimeout(this.timer)
			this.setState({ search: search })
			this.timer = setTimeout(() => {
				this.props.history.push(`/${this.pathSegment}/search?q=${search}`)
				this.props.fetchQuizzesByInputSearch(search)
			}, WAIT_INTERVAL)
		} else {
			this.fetchPage(1)
		}
	}

	render() {
		const { paginatedQuizzes, history } = this.props
		return (
			<List
				paginatedQuizzes={paginatedQuizzes}
				triggerChange={this.triggerChange}
				fetchPage={this.fetchPage}
				languageKey={this.languageKey}
				pathSegment={this.pathSegment}
				inputSearchValue={this.state.search}
				history={history}
			/>
		)
	}
}

QuizSearchList.propTypes = {
	paginatedQuizzes: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
	const query = new URLSearchParams(ownProps.location.search)
	const searchQuery = query.get('q') ? query.get('q') : ''
	const paginatedQuizzes = state.api.resources.quizzes.data.find(
		quiz => parseInt(quiz.page, 10) === 1
	)
	return {
		searchQuery: searchQuery,
		paginatedQuizzes: PaginatedDataModel.fromDtoWithQuizzes(paginatedQuizzes)
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			fetchQuizProjects,
			fetchQuizzesByInputSearch
		},
		dispatch
	)

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps
	),
	withStyles(eventUnitsStyle),
	withIntl
)(QuizSearchList)
